var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("CardItemTitle", {
            staticClass: "mr-2",
            attrs: { title: _vm.title },
          }),
          _vm.isDefaultShown ? _c("CardItemValue") : _vm._e(),
        ],
        1
      ),
      !_vm.isDefaultShown
        ? _vm._t("default", null, { collection: _vm.collection })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }